/**
 * Resources Services Module
 * Exports all resource management services and factory functions
 */
// Service exports
export * from './CourseService';
export * from './CourseCategoryService';
export * from './CourseSessionService';
export * from './UsageLogService';
export * from './CourseStatusService';
export * from './CourseCategoryStatusService';
export * from './CourseSessionStatusService';
export * from './CourseSessionTypeService';
// Service imports for factory
import { CourseService } from './CourseService';
import { CourseCategoryService } from './CourseCategoryService';
import { CourseSessionService } from './CourseSessionService';
import { UsageLogService } from './UsageLogService';
import { CourseStatusService } from './CourseStatusService';
import { CourseCategoryStatusService } from './CourseCategoryStatusService';
import { CourseSessionStatusService } from './CourseSessionStatusService';
import { CourseSessionTypeService } from './CourseSessionTypeService';
/**
 * Create all resources services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all resources service instances
 */
export function createResourcesServices(http, config) {
    return {
        course: new CourseService(http, config),
        courseCategory: new CourseCategoryService(http, config),
        courseSession: new CourseSessionService(http, config),
        usageLog: new UsageLogService(http, config),
        courseStatus: new CourseStatusService(http, config),
        courseCategoryStatus: new CourseCategoryStatusService(http, config),
        courseSessionStatus: new CourseSessionStatusService(http, config),
        courseSessionType: new CourseSessionTypeService(http, config),
    };
}
//# sourceMappingURL=index.js.map